import DeleteRounded from '@mui/icons-material/DeleteRounded'
import EditIcon from '@mui/icons-material/Edit'
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLandManagement } from '../LandManagementProvider'

/**
 * @todo
 * check and remove this as soon as the MUI GridActionsCellItem typings are updated
 */
const requiredProps = {} as {
  nonce: any
  onResize: any
  onResizeCapture: any
}

export const useFarmColumns = () => {
  const { t } = useTranslation('@cibo/landmanager/PaginatedFarmsTable')
  const { confirmDeleteFarm, openFarmDialog } = useLandManagement()

  return useMemo(
    () => ({
      name: {
        field: 'name',
        headerName: t('name'),
        minWidth: 200,
      },
      actions: {
        field: 'actions',
        type: 'actions',
        width: 24,
        getActions: (params: GridRowParams<{ id: string }>) => [
          <GridActionsCellItem
            icon={<EditIcon />}
            onClick={() => openFarmDialog({ farmId: params.row.id })}
            label={t('edit')}
            showInMenu
            {...requiredProps}
          />,
          <GridActionsCellItem
            icon={<DeleteRounded />}
            onClick={() => confirmDeleteFarm(params.row.id)}
            label={t('delete')}
            showInMenu
            {...requiredProps}
          />,
        ],
      },
    }),
    []
  )
}
